export default "__VITE_ASSET__DuMHOiJl__"